module.exports = require("./dsb.d.ts");